import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'renamePriceLevel'
})
export class RenamePriceLevelPipe implements PipeTransform {

  transform(value:any): any {

    if(value?.trim()?.toLowerCase() == "secondaire")
    {
      return "Tarif achat au carton"
    }
    else if(value?.trim()?.toLowerCase() == "primaire")
    {
      return "Tarif achat unité";
    }
    else return value;
  }

}
